import type { Category } from '@commercetools/platform-sdk';
import { RootCategories } from '@libs/core';
import { AlgoliaIndice } from '../types';

export const getAlgoliaIndice = (category: Category) => {
    // first check if category is root category
    if (category.externalId === RootCategories.US) {
        return AlgoliaIndice.CATEGORIES_US;
    }

    if (category.externalId === RootCategories.CA) {
        return AlgoliaIndice.CATEGORIES_CA;
    }

    // then check in parents
    const rootCategory = category.ancestors.find(
        ({ obj }) =>
            obj?.externalId === RootCategories.US ||
            obj?.externalId === RootCategories.CA
    );

    const algoliaIndice =
        rootCategory?.obj?.externalId === RootCategories.US
            ? AlgoliaIndice.CATEGORIES_US
            : AlgoliaIndice.CATEGORIES_CA;

    // if there is no root category it means that we are working locally
    // outside of the US and CA root categories and those test examples
    // won't get pushed to the Algolia since they do not belong anywhere
    return rootCategory ? algoliaIndice : null;
};
